import React from "react";
import LazyUIFooter from "./LazyUIFooter";
import UIHeader from "./UIHeader";
import PropTypes from "prop-types";

/** Loads header and locale switcher scripts
 * Lazy loads footer script
 */
const HeaderFooterLayout = ({ children, deployEnv = "qa", headerProps, footerProps, uiBaseUrl = '' }) => {
  return (
    <>
      <UIHeader uiBaseUrl={uiBaseUrl} env={deployEnv} loadFooter={false} {...headerProps} />
      {children}
      <LazyUIFooter uiBaseUrl={uiBaseUrl} deployEnv={deployEnv} {...footerProps} />
    </>
  );
};

HeaderFooterLayout.propTypes = {
  children: PropTypes.any,
  deployEnv: PropTypes.oneOf(["production", "stage", "qa"]),
  headerProps: PropTypes.shape({
    className: PropTypes.any,
    fdp: PropTypes.bool,
    disableSearchCss: PropTypes.bool,
  }),
  footerProps: PropTypes.shape({
    rootMargin: PropTypes.string,
  }),
};

export default HeaderFooterLayout;
